import { useCallback, useEffect, useState } from 'react';
import { apiUrl } from '@/config/api';

const useTariffs = (token, { errorMessage, publicFallback = false } = {}) => {
  const [topupTariffs, setTopupTariffs] = useState([]);
  const [gameCosts, setGameCosts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!token && !publicFallback) {
      setTopupTariffs([]);
      setGameCosts(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const endpoint = token ? '/api/tariffs' : '/api/public/tariffs';
      const requestOptions = token
        ? {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        : undefined;
      const response = await fetch(apiUrl(endpoint), requestOptions);

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || errorMessage || 'Не удалось загрузить тарифы');
      }

      const data = await response.json();
      setTopupTariffs(Array.isArray(data.topupTariffs) ? data.topupTariffs : []);
      setGameCosts(data.gameCosts || null);
    } catch (loadError) {
      setError(loadError.message);
      setTopupTariffs([]);
      setGameCosts(null);
    } finally {
      setLoading(false);
    }
  }, [errorMessage, publicFallback, token]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    topupTariffs,
    gameCosts,
    loading,
    error,
    reload: load,
  };
};

export default useTariffs;
